import { DEPLOY_ENV } from '@/defines/env'
import { trackRoutesMap } from './routes_map'
import { miniProgramEnv } from '../../defines/environment'
import { mpsCombination } from '../../utils/native_interactions/mps_combination'
import { isMallApp } from '@mc/mc-base-env/src/web/platform'
import tracerVuePlugin from '@mc/tracer-vue-plugin'
import { domain, TRACER_FETCH_URL } from '@/defines/environment/config'

import { Bridge } from '@mc/mc-jsbridge'
import { getTracerCurrentPageInfo } from './utils'
import Url from '@mc/mc-utils/js/url/url'

const routeHook = pageInfo => {
  const tracerCurrentPageInfo = getTracerCurrentPageInfo(pageInfo)
  if (miniProgramEnv.isMiniProgram) {
    mpsCombination.postMessage({
      data: {
        type: 'setCurrentPage',
        data: tracerCurrentPageInfo
      }
    })
  } else if (isMallApp()) {
    const hasNativeMethod = Bridge.hasNativeMethod('tick.setCurrentPage')
    if (hasNativeMethod) {
      Bridge.call('tick.setCurrentPage', tracerCurrentPageInfo)
    }
  }
}

const routeIntercepter = params => {
  const queryParams = new Url(window.location.href).parseQuerystring()
  tracerVuePlugin.tracer.setCurrentPage({
    refer_id: ''
  })
  return {
    ...params,
    tickreferrer: queryParams.tickreferrer || '',
    tickSessionId: queryParams.tickSessionId || ''
  }
}

export const projectConfig = {
  env: DEPLOY_ENV === 'online' ? 'production' : 'stage',
  pushLimit: 10,
  storeLimit: 100,
  autoPilot: true,
  routeMap: trackRoutesMap,
  routePathName: window.location.pathname,
  routeUrlPrefix: `https://online.${domain}`,
  showLog: DEPLOY_ENV !== 'online',
  autoRisk: false,
  fetchUrl: TRACER_FETCH_URL,
  routeHook,
  routeIntercepter
}
